import { isEmpty } from 'lodash';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { deleteDashboardMaterialAPI, deleteTextureAPI, updateDashboardMaterialsApi, updateTextureApi } from '../api/textures';
import { download } from '../common/DownloadFileController/downloadFile';
import { startDownload } from '../common/DownloadFileController/DownloadFileContext';
import { MODEL_TYPES } from '../constants/constants';
import { PERMISSION } from '../constants/permissionConstants';
import {
  ADMIN_MY_PRODUCTS_3DMODAL_EACH_V2,
  ADMIN_MY_PRODUCTS_TEXTURE_EDIT,
  ADMIN_MY_PRODUCTS_TEXTURES_EACH_V2,
  ADMIN_MY_PRODUCTS_UPLOADS_MOVE_TO_TEXTURE,
} from '../constants/routePathConstants';
import { MODE_EDIT } from '../constants/textureConstants';
import { apiGetDownloadTextures } from '../helpers/api';
import { apiErrorHandler } from '../helpers/axiosHelper';
import { textureDetailsModalActions } from '../redux/slicers/textureDetailsModalSlicer';
import { texturesSelectors } from '../redux/slicers/texturesSlicer';
import { useModelActions } from './useModelActions';
import { usePermissionsHandler, useStaticPermissions } from './usePermissions';
import { useUserContext } from '../contexts/UserContext';
import { successToast, warningToast } from '../helpers/toastHelper';
import { Mixpanel, MxEvent } from '../common/Mixpanel';
import { isCuratorPage } from '../helpers/urlHelper';
import { dashboardTabMaterialsSelectors } from '../redux/slicers/dashboardTabMaterialSlicer';
import { getExtensionFromURL } from '../helpers/jsHelper';
import JSZipUtils from 'jszip-utils/dist/jszip-utils';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';

export const useTextureActions = ({
  list = [],
  item,
  modelType,
  customModelActionsConfig,
  isMaterialList,
  isCustomMapsEdit = false,
  from = null,
  infoMessage = null,
} = {}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { handlePermissionEvent } = usePermissionsHandler();
  const { isEditor, isGuestUser } = useUserContext();
  const { hasPermission } = useStaticPermissions();
  const isMattressTexture = isCustomMapsEdit || (item?.is_map && item?.is_mattress_texture);

  const isMaterialOperation = isMaterialList || window.location.href.includes('my-products/materials')

  const { addToCollection, favouriteLoading, onDelete, onFavouriteToggle, onShare } =
    useModelActions({
      modelType: isMaterialOperation? MODEL_TYPES.MATERIAL: MODEL_TYPES.TEXTURE,
      item: item,
      selectors: isMaterialOperation ? dashboardTabMaterialsSelectors : texturesSelectors,
      updateApi: isMaterialOperation?  updateDashboardMaterialsApi :updateTextureApi,
      deleteConfig: {
        title: `Are you sure you want to delete this ${isMaterialOperation ? 'material': 'texture'}?`,
        deleteApi: isMaterialOperation ? deleteDashboardMaterialAPI : deleteTextureAPI,
      },
      ...customModelActionsConfig,
    });

  const [loading, setLoading] = useState(false);

  function handleCardClick({ id, name, texture_page_product }) {
    Mixpanel.track(true, MxEvent.CLICK_TEXTURE, {
      texture_id: id,
      texture_name: name,
      source: isCuratorPage() ? 'Curator' : 'Texture',
      recent_files: 'No',
    });

    const canAccessV2Page = isGuestUser() || hasPermission(PERMISSION.PRODUCT_PAGE_V2);

    if (modelType === MODEL_TYPES.UPLOADS || !canAccessV2Page) {
      const texture = item ? item : list.find((item) => item.id === id);
      dispatch(textureDetailsModalActions.show(texture));
      return;
    }

    if (texture_page_product) {
      window.open(ADMIN_MY_PRODUCTS_TEXTURES_EACH_V2?.replace(':id', id), '_blank');
    } else if (!isGuestUser() || isEditor) {
      const texture = item ? item : list.find((item) => item.id === id);
      dispatch(textureDetailsModalActions.generateContentShowModal(texture));
    } else {
      warningToast('Experience page is not created');
    }
  }

  const handleEditClick = (idOrList) => {
    let textures;
    if (item) {
      textures = [item];
    } else {
      textures = Array.isArray(idOrList) ? idOrList : [list.find((p) => p.id === idOrList)];
    }

    if (isEmpty(textures)) {
      throw new Error('textures are missing');
    }
    navigate(ADMIN_MY_PRODUCTS_TEXTURE_EDIT, {
      state: { textures, mode: MODE_EDIT, type: isMattressTexture ? 'custom-maps' : 'textures' },
    });
  };

  // async function handleDownloadClick(idOrList) {
  //   console.log(idOrList, 'idOrList')
  //   const ids = Array.isArray(idOrList) ? idOrList.map((i) => i.id) : [idOrList];
  //   if (!ids.length) return;

  //   setLoading(true);

  //   if (ids.length === 1) {
  //     const id = ids[0];
  //     let texture = list?.find((item) => item.id === id);
  //     if (!texture && item?.id === id) {
  //       texture = item;
  //     }

  //     if (from === 'sharedFiles') {}

  //     if (texture && texture.texture_file) {
  //       // download single texture file
  //       await download({ fileUrl: texture.texture_file });
  //       setLoading(false);
  //       return;
  //     }
  //   }

  //   let zipName = item ? item.name : idOrList.length === 1 ? idOrList[0].name : 'textures';
  //   await apiGetDownloadTextures({ ids, fileName: `${zipName}.zip` });
  //   setLoading(false);
  // }

  // async function handleDownloadClick(idOrList) {
  //   const ids = Array.isArray(idOrList) ? idOrList.map((i) => i.id) : [idOrList];
  //   if (!ids.length) return;

  //   setLoading(true);

  //   // --- Case 1: Single texture download ---
  //   if (ids.length === 1) {
  //     const id = ids[0];
  //     let texture;

  //     if (from === 'sharedFiles') {
  //       // Find shared file entry from passed list
  //       const sharedItem = idOrList.find((i) => i.id === id);
  //       if (sharedItem?.model_type === MODEL_TYPES.TEXTURE) {
  //         texture = sharedItem.data;
  //       }
  //     } else {
  //       texture = list?.find((item) => item.id === id);
  //       if (!texture && item?.id === id) texture = item;
  //     }

  //     const payload = {
  //       fileUrl: texture.texture_file,
  //       ...(from === 'custom-maps' && {
  //         fileName: 'customMaps'
  //       })
  //     }

  //     if (texture?.texture_file) {
  //       await download(payload);
  //       setLoading(false);
  //       return;
  //     }
  //   }

  //   // --- Case 2: Multiple textures (zip) ---
  //   let zipName;

  //   if (from === 'sharedFiles') {
  //     // Filter only texture items
  //     const textureItems = idOrList.filter(
  //       (i) => i.model_type === MODEL_TYPES.TEXTURE
  //     );

  //     if (textureItems.length === 1) {
  //       zipName = textureItems[0].data?.name || 'texture';
  //     } else {
  //       zipName = 'textures';
  //     }

  //     // override ids with texture IDs inside .data
  //     const textureIds = textureItems.map((i) => i.data?.id).filter(Boolean);
  //     await apiGetDownloadTextures({ ids: textureIds, fileName: `${zipName}.zip`, infoMessage });
  //   } else {
  //     zipName = item
  //       ? item.name
  //       : idOrList.length === 1
  //       ? idOrList[0].name
  //       : from === 'custom-maps' ? 'customMaps' : 'textures';

  //     await apiGetDownloadTextures({ ids, fileName: `${zipName}.zip` });
  //   }

  //   setLoading(false);
  // }


  async function handleDownloadClick(idOrList) {
    const ids = Array.isArray(idOrList) ? idOrList.map((i) => i.id) : [idOrList];
    if (!ids.length) return;

    setLoading(true);

    // --- Case 1: Single texture download ---
    if (ids.length === 1) {
      const id = ids[0];
      let texture;

      if (from === 'sharedFiles') {
        const sharedItem = idOrList.find((i) => i.id === id);
        if (sharedItem?.model_type === MODEL_TYPES.TEXTURE) {
          texture = sharedItem.data;
        }
      } else {
        texture = list?.find((item) => item.id === id);
        if (!texture && item?.id === id) texture = item;
      }

      const payload = {
        fileUrl: texture.texture_file,
        infoMessage,
        isMap: texture?.is_map
        
      };

      if (texture?.texture_file) {
        await download(payload);
        setLoading(false);
        return;
      }
    }

    // --- Case 2: Multiple textures (ZIP) ---
    try {
      let zipName;

      let textureItems;
      if (from === 'sharedFiles') {
        textureItems = idOrList.filter(
          (i) => i.model_type === MODEL_TYPES.TEXTURE
        );
        zipName =
          textureItems.length === 1
            ? textureItems[0].data?.name || 'texture'
            : 'textures';
      } else {
        textureItems = idOrList;
        const anyMap = idOrList.some((t) => t?.is_map);
        zipName =
          item?.name ||
          (idOrList.length === 1 ? idOrList[0].name : anyMap ? 'customMaps' : 'textures');
      }

      const downloadableFiles = textureItems
        .map((t) => {
          const data = from === 'sharedFiles' ? t.data : t;
          const fileUrl = data.texture_file || data.thumbnail || data.thumb;
          const prefix = data.is_map ? 'customMap' : 'texture'
          if (!fileUrl) return null;
          return {
            file: fileUrl,
            folderName: `${data.name?.trim() || prefix}_${data.id}`,
            filename: `${data.name?.trim() || prefix}${
              getExtensionFromURL(fileUrl) || '.jpg'
            }`,
          };
        })
        .filter(Boolean);

      if (downloadableFiles.length === 0) {
        warningToast('No valid files found for download.');
        setLoading(false);
        return;
      }

      const MAX_ZIP_SIZE_MB = 10240; // 10 GB
      const MAX_ZIP_SIZE_BYTES = MAX_ZIP_SIZE_MB * 1024 * 1024;

      const zip = new JSZip();
      let currentSize = 0;
      let count = 0;

      // Batch processing for large sets
      const processBatch = async (startIndex) => {
        const batch = downloadableFiles.slice(startIndex, startIndex + 10);
        if (batch.length === 0) return;

        for (const item of batch) {
          await new Promise((resolve, reject) => {
            JSZipUtils.getBinaryContent(item.file, (err, data) => {
              if (err) return reject(err);

              const fileSize = data?.length || 0;

              // Check cumulative size
              if (currentSize + fileSize > MAX_ZIP_SIZE_BYTES) {
                warningToast(
                  `ZIP size limit of ${MAX_ZIP_SIZE_MB} MB reached. Some files were skipped.`
                );
                return resolve('max-size-reached');
              }

              zip
                .folder(item.folderName)
                .file(item.filename, data, { binary: true });
              currentSize += fileSize;
              count++;
              resolve();
            });
          });
        }

        await processBatch(startIndex + 10);
      };

      await processBatch(0);

      if (count === 0) {
        warningToast('No files added to ZIP — all exceeded size limit.');
        setLoading(false);
        return;
      }

      const content = await zip.generateAsync({ type: 'blob' });
      saveAs(content, `${zipName}.zip`);
      const msg = infoMessage ? `Only ${count} texture${count > 1 ? 's' : ''} from your selection will be downloaded.`: `Successfully downloaded ${count} files.`
      successToast(msg);
    } catch (err) {
      console.error('ZIP download failed:', err);
      warningToast('Failed to create ZIP file.');
    } finally {
      setLoading(false);
    }
  }


  const handleUploadEditClick = handlePermissionEvent(
    PERMISSION.UPLOAD_TEXTURE,
    async (idOrList) => {
      let textures;
      if (item) {
        textures = [item];
      } else {
        textures = Array.isArray(idOrList) ? idOrList : [list.find((p) => p.id === idOrList)];
      }
      navigate(ADMIN_MY_PRODUCTS_UPLOADS_MOVE_TO_TEXTURE, {
        state: { textures, mode: 'move-to-textures' },
      });
    }
  );

  const onEdit = modelType === MODEL_TYPES.UPLOADS ? isMattressTexture ? handleEditClick : handleUploadEditClick : handleEditClick;

  return {
    loading,
    handleEditClick,
    handleDownloadClick,
    handleCardClick,
    handleUploadEditClick,
    onEdit,

    addToCollection,
    favouriteLoading,
    onDelete,
    onFavouriteToggle,
    onShare,
  };
};
